import React from 'react';
import { Column, Row } from 'hedron';
import ProductCell from '../ProductCell';
import { Products } from '../../common/models/Store/api/Products';

/* Types */
interface ProductRowProps {
  currencySymbol: string;
  isDesktop?: boolean;
  lazyLoad?: boolean;
  placeholderHeight?: string;
  placeholderWidth?: string;
  productRow: Products;
  s3BasePath: string;
  showSale?: boolean;
}

const styles = {
  alignSelf: 'stretch',
};

const ProductRow: React.FC<ProductRowProps> = ({
  currencySymbol,
  productRow,
  s3BasePath,
  isDesktop,
  showSale = false,
  lazyLoad,
  placeholderWidth,
  placeholderHeight,
}) => (
  <Row>
    {productRow.map(product => (
      <Column key={`product-row-${product.product_id}`} fluid={isDesktop} lg={4} md={3} sm={3} style={styles} xs={6}>
        <ProductCell
          currencySymbol={currencySymbol}
          isDesktop={isDesktop}
          lazyLoad={lazyLoad}
          placeholderHeight={placeholderHeight}
          placeholderWidth={placeholderWidth}
          product={product}
          s3BasePath={s3BasePath}
          showSale={showSale}
        />
      </Column>
    ))}
  </Row>
);

export default ProductRow;
